export function helpCardsSlider() {
    const $slider = $(".help-cards");
    const $sliderNav = $(".help-cards-nav");
    const numberOfSlides = $sliderNav.find('.item').length;


    function sliderInit() {

        $slider.slick({
            slidesToShow: 1,
            slidesToScroll: 1,
            dots: true,
            arrows: false,
            mobileFirst: true,
            responsive: [{
                breakpoint: 1199,
                settings: "unslick"
            }],
            asNavFor: $sliderNav
        });

        $sliderNav.slick({
            slidesToShow: 3,
            slidesToScroll: 1,
            asNavFor: $slider,
            focusOnSelect: true,
            mobileFirst: true,
            responsive: [{
                breakpoint: 1199,
                settings: "unslick"
            }],
        });

    }

    $(window).on("load resize", function () {
        if (window.innerWidth < 1199 && !$slider.hasClass("slick-initialized")) {
            sliderInit();
        }
        if ($slider.hasClass("slick-initialized")){
            const slidesShown = $sliderNav.slick('slickGetOption', 'slidesToShow');
            if (numberOfSlides <= slidesShown) {
                setTimeout(() => {
                    $sliderNav.find('.slick-track').css('transform', 'translate3d(0px, 0px, 0px)');
                }, 100);
            }
        }
    });
}


// WEBPACK FOOTER //
// ./assets/js/modules/helpCardsSlider.js